// Created by Michael Abadi Santoso
// 31 May 2020
// Copyright OKKAMI

///
/// Use this class for exposing the styling on product list page
///

// TECHDEBT: Please move List and some common style into global instead
import styled from "styled-components";

const Image = styled.img`
  height: 500px;
  width: 100%;
  object-fit: cover;
  margin: auto 0;
`;

const ImageStyle = styled.img`
  border-color: brown;
  border: ${(props) =>
    props.border
      ? `5px solid ${
          props.app_home_color_secondary
            ? props.app_home_color_secondary
            : "brown"
        }`
      : "0px"};
  height: 100%;
`;

const ListTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductPanel = styled.div`
  position: relative;
  margin: ${(props) => props.margin};
  width: 100%;
`;

const ProductPrice = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`;

const ListHeaderTitle = styled.div`
  color: ${(props) =>
    props.app_home_list_item_title_color
      ? props.app_home_list_item_title_color
      : "black"};
  overflow: hidden;
  display: ${(props) => (props.hide ? "none" : "-webkit-box")};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 16px;
`;

const ListSectionTitle = styled.div`
  font-size: 14pt;
  color: ${(props) =>
    props.app_home_menu_category ? props.app_home_menu_category : "black"};
  padding: 16px;
  text-align: left;
`;

const ListSubTitle = styled.div`
  color: ${(props) =>
    props.app_home_list_item_subtitle_color
      ? props.app_home_list_item_subtitle_color
      : "gray"};
  font-weight: normal;
  margin: ${(props) =>
    props.haveImage ? "0px 20px 20px 0" : "0px 20px 20px 0"};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: 12px;
  word-break: break-word;
  font-family: "Open Sans", "Montserrat", sans-serif;
  white-space: break-spaces;
`;

const ListSubTitleAbout = styled.div`
  color: ${(props) =>
    props.app_home_list_item_subtitle_color
      ? props.app_home_list_item_subtitle_color
      : "gray"};
  font-weight: normal;
  margin: ${(props) =>
    props.haveImage ? "0px 20px 20px 0" : "0px 20px 20px 0"};
  overflow: hidden;
  width: 75%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: 12px;
  word-break: break-word;
`;

const TopPadding = styled.div`
  height: 5rem;
`;

const NameStyle = styled.div`
  font-size: 10pt;
  margin-right: 6px;
  color: ${(props) =>
    props.app_home_list_item_subtitle_color
      ? props.app_home_list_item_subtitle_color
      : "gray"};
`;

const DateStyle = styled.div`
  color: ${(props) =>
    props.app_home_list_item_title_color
      ? props.app_home_list_item_title_color
      : "black"};
  font-size: 16px;
`;

const SmallCart = styled.div`
  width: 25px;
  padding: 0 0 5px 0;
  position: absolute;
  background-color: ${(props) =>
    props.app_home_color_secondary ? props.app_home_color_secondary : "brown"};
`;

const ImageBag = styled.img`
  height: 8px;
  object-fit: cover;
`;

const Cart = styled.div`
  width: 70%;
  height: 20%;
  border-radius: 2px;
  background-color: ${(props) =>
    props.app_home_color_secondary ? props.app_home_color_secondary : "brown"};
  border: 1px solid #fff;
`;

const Quantity = styled.h5`
  color: white;
  text-align: center;
`;

const TitleLoading = styled.div`
  color: black;
  text-align: center;
  position: fixed;
  top: 50%;
  left: calc(50% - 36px);
`;

const BoxLastItem = styled.div`
  margin: 80px 0 0 0;
`;

const BoxLanguage = styled.div`
  position: fixed;
  right: 20px;
  bottom: 80px;
  height: 56px;
  width: 56px;
  background-color: rgba(0, 0, 0, 0.11);
  border-radius: 30px;
`;

const BoxBottomBar = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  height: 50px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.11);
`;

export {
  Image,
  ListTitle,
  ListHeaderTitle,
  ListSubTitle,
  TopPadding,
  ImageStyle,
  NameStyle,
  DateStyle,
  ListSectionTitle,
  SmallCart,
  ImageBag,
  Cart,
  Quantity,
  TitleLoading,
  ProductPrice,
  ProductPanel,
  BoxLastItem,
  ListSubTitleAbout,
  BoxLanguage,
  BoxBottomBar,
};
